import React from 'react';

import { normalizedTranslate } from '@rbilabs/components-library';
import styled from 'styled-components';

import ActionButton from 'components/action-button';
import Picture from 'components/picture';
import { useLocationContext } from 'state/location';

const CallToActionHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const CallToActionHeading = styled.h2``;
const CallToActionSubheading = styled.h3`
  color: ${Styles.color.primary};
  font-family: ${Styles.fontFamily.brand};
  font-weight: ${Styles.fontWeight.normal};
  position: relative;
  display: inline-block;
  transform-origin: 0 0;
  transform: rotate(-5deg) ${normalizedTranslate(0, '15%')};
  order: 1;
`;
const CallToActionBody = styled.p`
  margin-block-start: 1rem;
  margin-block-end: 2rem;
  margin-inline: 0;
`;
const Image = styled(Picture)`
  display: block;
  width: 100%;
  height: auto;

  ${Styles.mobileSmall} {
    order: -1;
    max-width: 66%;
    margin: 0 auto;
  }
`;

const CallsToAction = styled.div`
  width: 90%;
  max-width: 920px;
  margin: 1rem auto;
`;

const CallToAction = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: ${props => (props.$hasImage ? 'repeat(2, 1fr)' : '1fr')};
  justify-items: ${props => (props.$hasImage ? '' : 'center')};
  grid-gap: 0 10%;

  & + & {
    margin-block-start: 4rem;
  }

  &:nth-child(even) {
    grid-template-columns: ${props => (props.$hasImage ? '40% 50%' : '1fr')};
    & > ${Image} {
      order: -1;
    }
  }

  ${Styles.mobile} {
    grid-template-columns: ${props => (props.$hasImage ? '60% 30%' : '1fr')};
    &:nth-child(even) {
      grid-template-columns: ${props => (props.$hasImage ? '30% 60%' : '1fr')};
    }
  }

  ${Styles.mobileSmall} {
    padding: 1.5rem 0;
    grid-template-columns: 100%;
    grid-template-rows: auto auto;
    grid-gap: 1rem;

    &:nth-child(even) {
      grid-template-columns: 100%;
    }
  }

  ${CallToActionHeading} {
    font-size: 1.75rem;
    font-weight: 700;
    line-height: 1;
    order: 2;

    ${Styles.mobile} {
      text-align: center;
    }
  }

  ${CallToActionSubheading} {
    ${Styles.mobile} {
      font-size: 1.5rem;
    }
  }

  ${CallToActionHeading},
  ${CallToActionSubheading} {
    margin: 0;
    padding: 0;
  }

  & > div {
    align-self: center;
  }

  ${CallToActionHeading} {
    margin-block-end: 1rem;

    ${Styles.mobile} {
      margin-block-start: 1rem;
    }
  }
`;

export default function CallToActionWidget(props) {
  const { navigate } = useLocationContext();

  return (
    <CallsToAction>
      {props.callToActionContent.map((cta, index) => {
        const hasImage = Boolean(cta.image);

        return (
          <CallToAction key={index} $hasImage={hasImage}>
            <div>
              <CallToActionHeaderContainer>
                {cta.heading && <CallToActionHeading>{cta.heading?.locale}</CallToActionHeading>}
                {cta.subheading && (
                  <CallToActionSubheading>{cta.subheading?.locale}</CallToActionSubheading>
                )}
              </CallToActionHeaderContainer>
              {cta.body && <CallToActionBody>{cta.body?.locale}</CallToActionBody>}
              {cta.buttonText && (
                <ActionButton
                  fullWidth
                  variant="contained"
                  color="primary"
                  onClick={() => navigate(cta.link?.locale)}
                  wrapText
                >
                  {cta.buttonText?.locale}
                </ActionButton>
              )}
            </div>
            {hasImage && <Image image={cta.image?.locale} />}
          </CallToAction>
        );
      })}
    </CallsToAction>
  );
}
